import { CreateNewSessionAndGetChatBotRootRequest } from "../../Model/Request/ChatBot/CreateNewSessionAndGetChatBotRootRequest";
import { GetNodeChildsListResponse } from "../../Model/Response/ChatBot/GetNodeChildsListResponse";
import { ApiBaseResponse } from "../../Model/Response/Common/ApiBaseResponse";
import { GlobalOperations } from "../Common/GlobalOperations";

export async function CreateNewSessionAndGetChatBotRoot(request: CreateNewSessionAndGetChatBotRootRequest): Promise<ApiBaseResponse<GetNodeChildsListResponse> | null> {

    if (request == null)
        return null;

    let response = await fetch(GlobalOperations.BaseUrl + "api/ChatBotController/CreateNewSessionAndGetChatBotRoot",
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(request)
        });

    let data: ApiBaseResponse<GetNodeChildsListResponse> = await response.json();
    return data;
}


export async function GetNodeChildsList(header: string, NodeId: number): Promise<ApiBaseResponse<GetNodeChildsListResponse> | null> {

    let response = await fetch(GlobalOperations.BaseUrl + "api/ChatBotController/GetNodeChildsList/" + NodeId,
        {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': header

            }
        });

    let data: ApiBaseResponse<GetNodeChildsListResponse> = await response.json();
    return data;
}
